export * from './typography.component';